import { render, staticRenderFns } from "./PayablesView.vue?vue&type=template&id=4696f950&scoped=true"
import script from "./PayablesView.vue?vue&type=script&lang=js"
export * from "./PayablesView.vue?vue&type=script&lang=js"
import style0 from "./PayablesView.vue?vue&type=style&index=0&id=4696f950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4696f950",
  null
  
)

export default component.exports